import React, {useState, useRef} from 'react'
import SarasWrapper from '../../container/SarasWrapper'
import SarasMenu from '../../repeater/menu/SarasMenu'
import SarasFormMenuRow from '../../repeater/menu/SarasFormMenuRow'
import ActionButton from '../../input/buttons/button/SarasButton'
import SarasPopup from '../../container/popup/SarasPopup'
import SarasDialog from '../../container/popup/SarasDialogDefAction';
import SarasTrans from '../../notifications/SarasTrans'
import SarasInput from '../../input/textField/SarasInput'
import {DoneAllIcon} from '../../decor/SarasIcons';

const FormShare = (props) => {
    const { formObject, action, directForSingle, rowKey, headerKey, disableToHide, customWrapper, ...restProps } = props;

    const [selectedItem, setSelectedItem] = useState(null);
    const [sharePopup, setSharePopup] = useState(false);
    const [copied, setCopied] = useState(false);
    const viewData = formObject.getFormRow(rowKey, headerKey);

    const values = viewData ? Object.values(viewData.rowValues) : [];
    const disabled = disableToHide ? !values || values.length === 0 : false;
    const popupRef = useRef();

    const renderFormMenu = () => {
        
        return (
            <ActionButton 
            className={'uiContentCenter uiButtonAppText2'}
            starIcon={'share'}
            disabled={disabled} 
            {...restProps} 
            />
        )
    }

    const getSelectedRow = (value) => {
        // console.log("report value", value);
        if(value){
            // let selectedItem = viewData.rowValues[value];
            // if(!selectedItem)
            let selectedMenu = viewData.rowValues[Object.keys(viewData.rowValues)[value]];
            // console.log("report item", Object.keys(viewData.rowValues)[value], selectedItem);
            return selectedMenu;
        }
    }

    const onMenuItemClick = (e, value) => {
        let selectedMenu = getSelectedRow(value);

        setSelectedItem(selectedMenu);
        setSharePopup(true);
    }

    if (!viewData && !disableToHide)
        return (null)

    const handleSharePopupClosed = () => {
        setSelectedItem(null);
        setSharePopup(false);
        setCopied(false);
    }

    const onCopyClick = () => {
        navigator.clipboard.writeText(selectedItem.dataList.shareUrlLong);
        setCopied(true);
    }



    //render menu if more than one option
    return (
        <SarasWrapper customWrapper={customWrapper}>
            <div ref={popupRef}>
                <SarasMenu menuTrigger={renderFormMenu()}
                    dataList={values}
                    disableToHide={disableToHide}
                    menuItem={SarasFormMenuRow} onSelection={onMenuItemClick} />
            </div>
            {sharePopup && selectedItem && (
            <SarasPopup anchorRef={popupRef} open={true}
                onClose={handleSharePopupClosed}
                >
                <SarasDialog formStyle={{ width: '320px', height:'200px' }} 
                    contentStyle={{ height:'85px', overflow:'hidden' }}  title={<SarasTrans value='Share Link' />} 
                    actionName=""
                    cancelName='Close' cancelFunction={handleSharePopupClosed} >
                    <div className='uiBox uiFormFree'>
                        <div className='uiFlexBox'>
                            <span className="uiLbl uiBold"><SarasTrans value={selectedItem.valF} />:</span>
                        </div>
                        <div className='uiFlexBox'>
                            <SarasInput style={{width: '200px'}} value={selectedItem.dataList.shareUrlLong} />
                            <ActionButton ksc="r" 
                                starIcon="copy" starIconClassName="uiBrandColor1" 
                                onClick={onCopyClick}
                                className={`uiContentCenter uiButtonAppText2`}>
                                <span className='uiAppText2Compliment'><SarasTrans value="Copy" /></span>
                            </ActionButton>
                        </div>
                        <div>
                            {copied && (
                                <div className='uiFlexBox'>
                                    <DoneAllIcon className='uiColorGreen'/>
                                    <span className='uiColorGreen'><SarasTrans value="Link copied" /></span>
                                </div>
                            )}
                        </div>
                    </div>
                </SarasDialog>
            </SarasPopup>)}
        </SarasWrapper>
    )
}

export default FormShare;
